import { getExtensibilityState } from 'owa-addins-store';

export default function isTaskPaneRunning(controlId: string): boolean {
    return [...getExtensibilityState().taskPanes.values()].some(
        taskPane => taskPane.controlId === controlId
    );
}
